// src/store/mutation.js
import * as types from './mutation-type'

const mutations = {
  // 原有mutations...

  // 新增登录相关mutations
  [types.SET_USER](state, user) {
    state.user = user
  },

  [types.SET_TOKEN](state, token) {
    state.token = token
    // 同时存储到localStorage
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },

  [types.SET_LOGGED_IN](state, status) {
    state.loggedIn = status
  },

  [types.SET_LOGIN_LOADING](state, loading) {
    state.loginLoading = loading
  },

  [types.SET_REGISTER_LOADING](state, loading) {
    state.registerLoading = loading
  },

  [types.CLEAR_USER](state) {
    state.user = null
    state.token = ''
    state.loggedIn = false
    localStorage.removeItem('token')
  },

  [types.SET_WISH_LOADING](state, loading) {
    state.wishLoading = loading
  },

  [types.ADD_WISH](state, wish) {
    if (!state.wishes) {
      state.wishes = []
    }
    state.wishes.unshift(wish)
  },
}

export default mutations
